import React, { Component } from "react";
import './PaymentHistory.css'

export class PaymentHistory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            isPost: false,
            codePay: 0,
            settingsRequired: {
                ProcessId: false,
                ClientId: this.props.ClientId,
                Comment: false,
                Payment: false,
                PaymentType: false,
                WayToPay: false,
                Confirm: false
            },

            model: {
                ProcessId: 0,
                ClientId: this.props.ClientId,
                Comment: '',
                Payment: 0,
                PaymentType: '',
                WayToPay: '',
                SendButt: false
            },

            processFind: [],
            currentInput: null
        }
    }

    componentDidMount() {
        this.getHistoryPaymentByUser();
        document.querySelector('#openHistoryPayment').click();

        this.confirmDeletePay = this.confirmDeletePay.bind(this);
        this.deletePayment = this.deletePayment.bind(this);
    }

    async getProcess(event) {
        this.state.processFind = [];
        if (event.currentTarget.value && event.currentTarget.value.length > 2) {
            this.setState({ loading: true, currentInput: event.currentTarget });
            const request = {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `bearer ${localStorage.getItem('token')}`
                }
            }
            event.currentTarget.focus();
            let response = await fetch(`Process/GetProcessByLike?param=${event.currentTarget.value}`, request);
            if (response.redirected) {
                window.location.href = response.url;
            }
            this.setState({ loading: false });
            if (response.status == 200) {
                let data = await response.json();
                this.setState({ processFind: data });
                this.state.currentInput.focus();
            }
            else {
                alert('Error obteniendo los procesos');
            }

        }
    }

    async getHistoryPaymentByUser(event) {

        this.setState({ loading: true });
        const request = {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            }
        }
        let response = await fetch(`HistoryPayment/GetHistoryPaymentByUser?clientId=${this.props.ClientId}`, request);
        if (response.redirected) {
            window.location.href = response.url;
        }
        this.setState({ loading: false });
        if (response.status == 200) {
            let data = await response.json();
            this.setState({ historyPayment: data });
        }
        else {
            alert('Error el historico de pagos');
        }
    }

    async saveForm() {
        this.setState({ isPost: true });
        if (this.formIsValid()) {
            this.setState({ loading: true });
            const request = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify(this.state.model)
            }

            let response = await fetch('HistoryPayment/Insert', request);
            this.setState({ loading: false });
            switch (response.status) {
                case 200:
                    this.setState({
                        settingsRequired: {
                            ProcessId: false,
                            ClientId: this.props.ClientId,
                            Comment: false,
                            Payment: false,
                            PaymentType: false,
                            WayToPay: false,
                            Confirm: false
                            
                        },

                        model: {
                            ProcessId: 0,
                            ClientId: this.props.ClientId,
                            Comment: '',
                            Payment: 0,
                            PaymentType: '',
                            WayToPay: '',
                            PaymentDate: null,
                            ReferenceCode: '',
                            SendButt: false
                        },
                    });
                    this.closeModal();
                    alert('Pago guardado con éxito');
                    break;
                case 500:
                    alert('Error procesando el pago, inténtelo de nuevo');
                    break;
                default:
            }
        }
    }

    formIsValid() {
        return Object.values(this.state.settingsRequired).find((a) => { return !a }) == undefined ? true : false;
    }

    handleSelectProcess(event) {
        document.querySelector('#searchProcess').value = '';
        this.state.model.ProcessId = parseInt(event.currentTarget.dataset.id);
        this.state.settingsRequired.ProcessId = true;
        this.setState({ processNameSelected: event.currentTarget.value, processFind: [], city: event.currentTarget.dataset.city, processNumber: event.currentTarget.dataset.processnumber });
    }

    removeSelectProcess(event) {
        this.state.model.ProcessId = 0;
        this.state.settingsRequired.ProcessId = false;
        this.setState({ processNameSelected: '', processFind: [] });
    }

    formatCurrency(val) {

        var formatted = new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: 'COP',
            minimumFractionDigits: 2
        }).format(val);
        return formatted;
    }

    setModel(event) {

        this.state.model['ClientId'] = this.props.ClientId;

        if (event.currentTarget.value) {
            this.state.model[event.currentTarget.dataset.name] = event.currentTarget.dataset.iscurrency ? parseInt(event.currentTarget.value) : event.currentTarget.value;
            this.state.settingsRequired[event.currentTarget.dataset.name] = true;
        } else {
            this.state.model[event.currentTarget.dataset.name] = '';
            this.state.settingsRequired[event.currentTarget.dataset.name] = false;
        }

        if (event.currentTarget.dataset.iscurrency) {
            this.formatCurrency(event);
        }
    }

    closeModal() {
        document.querySelector('#closeModal').click();
        this.props.ResetClient();
    }

    validateFormatCurrency(e) {
        var code = (e.which) ? e.which : e.keyCode;
        if (code === 46 || code === 101 || code === 45) {
            e.preventDefault()
        }
    }

    confirmDeletePay(e) {
        this.setState({ codePay: parseInt(e.currentTarget.dataset.code), payValue: e.currentTarget.dataset.pay })
    }

    async deletePayment() {
        this.setState({ loading: true });
        const request = {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            }
        }
        let response = await fetch(`HistoryPayment/Delete?id=${this.state.codePay}`, request);
        if (response.redirected) {
            window.location.href = response.url;
        }
        if (response.status == 200) {
            this.setState({
                historyPayment: { historyPayment: this.state.historyPayment.historyPayment.filter((a) => { return a.id != this.state.codePay }) },
                codePay: 0,
                payValue: '',
                loading: false
            });
            document.querySelector('#confirm-delete .close-modal-delete').click();
            alert('El pago ha sido borrado con éxito');
        }
        else {
            alert(`Error borrando el pago con código: ${this.state.codePay}`);
        }
    }

    showDelete() {

    }
    render() {

        return (
            <div className="wrapp-payment-history">

                <div class="modal fade" id="confirm-delete" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                Mensaje de confirmación
                            </div>
                            <div class="modal-body">
                                ¿Está seguro que desea borrar el pago con id: {this.state.codePay} y valor de: {this.state.payValue}?
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-default close-modal-delete" data-dismiss="modal">Cancelar</button>
                                <a class="btn btn-danger btn-ok" onClick={this.deletePayment}>Aceptar</a>
                            </div>
                        </div>
                    </div>
                </div>

                <button id="openHistoryPayment" type="button" class="btn btn-primary" data-toggle="modal" data-target="#modalHistoryPayment" hidden>
                    Launch demo modal
                </button>

                <div class="modal fade" id="modalHistoryPayment" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Mensajes</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={(event) => { this.closeModal() }}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body payment">
                                <div>
                                    {this.state.historyPayment ? this.state.historyPayment.historyPayment.map((e) => {
                                        return <div className="wrapp-history-payment">
                                            <div className="item">
                                                <b>Id: </b>
                                                {e.id}
                                            </div>
                                            <div className="item">
                                                <b>Proceso: </b>
                                                {e.processName}
                                            </div>
                                            <div className="item">
                                                <b>Comentario del coordinador: </b>
                                                {e.comment}
                                            </div>
                                            <div className="item">
                                                <b>Tipo de pago: </b>
                                                {e.paymentType}
                                            </div>
                                            <div className="item">
                                                <b>Medio de pago: </b>
                                                {e.wayToPay}
                                            </div>
                                            <div className="item">
                                                <b>Pago: </b>
                                                {this.formatCurrency(e.payment)}
                                            </div>

                                            <div className="item">
                                                <b>Ciudad: </b>
                                                {e.city}
                                            </div>
                                            <div className="item">
                                                <b>N&uacute;mero de proceso: </b>
                                                {e.processNumber}
                                            </div>

                                            {e.paymentDate != null && e.referenceCode != null ? <div>
                                                <div className="item">
                                                    <b>Fecha de transferencia o Payu: </b>
                                                    {e.paymentDate}
                                                </div>
                                                <div className="item">
                                                    <b>Referencia de pago: </b>
                                                    {e.referenceCode}
                                                </div>
                                            </div> : null}

                                            <div className="item">
                                                <b>Fecha registro del pago: </b>
                                                {e.createOnDate}
                                            </div>
                                            <div className="item">
                                                <b>¿Se envió colilla de pago?: </b>
                                                {e.sendButt ? 'Sí' : 'No'}
                                            </div>

                                            {
                                                document.querySelector('#appRol').value.indexOf('Administrador') > -1 || document.querySelector('#appRol').value.indexOf('Director') > -1 ?
                                                    <div className="delete-payment">
                                                        <a href="#" onClick={this.confirmDeletePay} data-toggle="modal" data-target="#confirm-delete" data-code={e.id} data-pay={this.formatCurrency(e.payment)}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                                                <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                                                            </svg>
                                                        </a>
                                                    </div> : null
                                            }


                                        </div>
                                    }) : null}
                                    <b>Pago total: </b> {this.state.historyPayment && this.state.historyPayment.historyPayment.length > 0 ? this.formatCurrency(this.state.historyPayment.historyPayment.map(c => c.payment).reduce((a, b) => a + b)) : 0}
                                </div>

                                <div className="form">
                                    <div className="form-group">
                                        <label>Proceso</label>

                                        {!this.state.processNameSelected ?
                                            <input type="text" id="searchProcess" className="form-control" disabled={this.state.loading} onChange={(event) => { this.getProcess(event) }} /> :
                                            null
                                        }

                                        {this.state.processNameSelected ?
                                            <div className="form-control">
                                                <span>{this.state.processNameSelected}</span>
                                                <span className="remove" onClick={() => { this.removeSelectProcess() }} title="Eliminar filtro">x</span>
                                            </div> :
                                            null
                                        }

                                        {this.state.loading ? <span>Por favor espere...</span> : null}
                                        {!this.state.settingsRequired.ProcessId && this.state.isPost ? <span className="error required">Campo requerido</span> : null}

                                        {this.state.processFind ? this.state.processFind.map((e) => <ul>
                                            <input type="button" value={e.description} data-id={e.id} data-city={e.city} data-processNumber={e.processNumber} onClick={(event) => { this.handleSelectProcess(event) }} />
                                        </ul>) : null}

                                    </div>
                                    <div className="form-group">
                                        <label>Comentario del coordinador</label>
                                        <textarea className="form-control" data-name="Comment" onBlur={(event) => { this.setModel(event) }} />
                                        {!this.state.settingsRequired.Comment && this.state.isPost ? <span className="error required">Campo requerido</span> : null}
                                    </div>

                                    <div className="form-group">
                                        <label>Número del proceso</label>
                                        <input type="text" className="form-control" value={this.state.processNumber} readOnly="true" />
                                    </div>
                                    <div className="form-group">
                                        <label>Ciudad</label>
                                        <input type="text" className="form-control" value={this.state.city} readOnly="true" />
                                    </div>

                                    <div className="form-group">
                                        <label>Valor en pesos (COP)</label>
                                        <input type="number" className="form-control" data-isCurrency="true" data-name="Payment" placeholder="Ingrese el valor sin punto ni coma"
                                            onKeyPress={
                                                this.validateFormatCurrency
                                            }
                                            onBlur={(event) => {
                                                this.setModel(event)
                                            }} />
                                        {!this.state.settingsRequired.Payment && this.state.isPost ? <span className="error required">Campo requerido</span> : null}
                                    </div>
                                    <div className="form-group">
                                        <ul>
                                            <li>
                                                <label for="Pass">
                                                    <input id="Pass" type="radio" name="paymentType" value="Abono" data-name="PaymentType" onClick={(event) => { this.setModel(event) }} /> Abono
                                                </label>
                                            </li>
                                            <li>
                                                <label for="FullPayment">
                                                    <input id="FullPayment" type="radio" name="paymentType" value="Pago total" data-name="PaymentType" onClick={(event) => { this.setModel(event) }} /> Pago total
                                                </label>
                                            </li>
                                        </ul>
                                        {!this.state.settingsRequired.PaymentType && this.state.isPost ? <span className="error required">Campo requerido</span> : null}
                                    </div>
                                    <div className="form-group">
                                        <ul>
                                            <li>
                                                <label for="Cash">
                                                    <input id="Cash" type="radio" name="way-to-pay" value="Efectivo" data-name="WayToPay" onClick={(event) => { this.setModel(event); this.setState({ showDetalPayment: false }) }} /> Efectivo
                                                </label>
                                            </li>
                                            <li>
                                                <label for="Transfer">
                                                    <input id="Transfer" type="radio" name="way-to-pay" value="Transferencia" data-name="WayToPay" onClick={(event) => { this.setModel(event); this.setState({ showDetalPayment: true }) }} /> Transferencia
                                                </label>
                                            </li>
                                            <li>
                                                <label for="Payu">
                                                    <input id="Payu" type="radio" name="way-to-pay" value="Botón de Payu" data-name="WayToPay" onClick={(event) => { this.setModel(event); this.setState({ showDetalPayment: true }) }} /> Botón de Payu
                                                </label>
                                            </li>
                                        </ul>
                                        {!this.state.settingsRequired.WayToPay && this.state.isPost ? <span className="error required">Campo requerido</span> : null}
                                    </div>

                                    {this.state.showDetalPayment ?
                                        <div>
                                            <div className="form-group">
                                                <label>N&uacute;mero de referencia</label>
                                                <input type="text" className="form-control" data-name="ReferenceCode" onBlur={(event) => { this.setModel(event) }} />
                                                <span className="error info required">Este campo no es obligatorio, pero si tiene la referencia de pago, agréguela</span>
                                            </div>
                                            <div className="form-group">
                                                <label>Fecha de pago</label>
                                                <input type="datetime-local" className="form-control" data-name="PaymentDate" onBlur={(event) => { this.setModel(event) }} />
                                                <span className="error info required">Este campo no es obligatorio, pero si tiene la fecha de pago, agréguela</span>
                                            </div>
                                        </div>
                                        : null}

                                    <div className="form-group">
                                        <label for="Confirm">
                                            <input type="checkbox" id="Confirm" onClick={(event) => {
                                                this.state.settingsRequired.Confirm = event.currentTarget.checked;
                                            }} />Si ya verificó que toda la información es correcta, marque esta casilla.
                                        </label>
                                        {!this.state.settingsRequired.Confirm && this.state.isPost ? <span className="error required">Campo requerido</span> : null}

                                    </div>
                                    <div className="form-group">
                                        <label for="Copy">
                                            <input type="checkbox" id="Copy" onClick={(event) => {
                                                this.state.model.SendButt = event.currentTarget.checked;
                                            }} />Para enviar el comprobante de pago por correo, marque esta casilla.
                                        </label>
                                    </div>
                                    <div className="form-group">
                                        {this.state.errorCurrency ? <span className="error required">Hay un error en el formulario, por favor verifique para guardar la información</span> : null}
                                    </div>
                                    <div className="form-group">
                                        <input type="button" className="btn btn-primary" value={this.state.loading ? 'Procesando...' : 'Guardar'} onClick={() => { this.saveForm() }} disabled={this.state.loading} />
                                    </div>
                                </div>

                            </div>
                            <div class="modal-footer">
                                <button id="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal" onClick={(event) => { this.closeModal() }}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        )
    }
}